<div class="container">
  {{ categoryName() }}
</div>
